module.exports = __webpack_public_path__ + "static/img/car_bcg2.6f0a446c.png";